import {BrowserModule} from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ProgressBarModule} from 'primeng/progressbar';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ButtonModule} from 'primeng/button';
import {SharedUIModule} from './shared/shared-ui-module';
import {SpinnerInterceptorService} from './core/spinner-interceptor.service';
import {AuthService} from './core/auth.service';
import {TokenInterceptorService} from './core/token-interceptor.service';
import {LandingPageComponent} from './landing-component/landing-component.component';
import {AppInjector} from './shared/injector.service';
import {DataPollingService} from './shared/data-polling.service';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';

@NgModule({
  declarations: [AppComponent, LandingPageComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ButtonModule,
    SharedUIModule,
    ProgressBarModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    AuthService,
    DataPollingService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private readonly injector: Injector) {
    AppInjector.setInjector(injector);
  }
}
